(() => {
  const Saint = window.Saint || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents, format = Saint.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    const fmt = (num, decimals, thousands = ',', decimal = '.') => {
      const [whole, frac] = (num / 100).toFixed(decimals).split('.');
      const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + decimal + frac : withSep;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }
  Saint.formatMoney = formatMoney;

  const escapeHtml = (str = '') => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Overlays (drawer / mobile menu) ---------- */
  let lastFocus = null;
  function openOverlay(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const focusable = el.querySelector('[role="dialog"], button, a');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 50);
  }
  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  /* Mobile menu */
  const mobileMenu = $('[data-mobile-menu]');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      openOverlay(mobileMenu);
      $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    }
    if (e.target.closest('[data-menu-close]')) {
      closeOverlay(mobileMenu);
      $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }
  });

  /* ---------- Cart ---------- */
  const drawer = $('[data-cart-drawer]');
  const P = Saint.protection;
  const TAG_ICON = '<svg class="icon icon-tag" aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9Z"/><circle cx="7.5" cy="7.5" r="1.3"/></svg>';
  const SHIELD_ICON = '<svg class="icon icon-shield" aria-hidden="true" focusable="false" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 4.5 6v5.5c0 4.6 3.1 8.3 7.5 9.5 4.4-1.2 7.5-4.9 7.5-9.5V6L12 3Z"/><path d="m8.8 12.2 2.2 2.2 4.3-4.4"/></svg>';

  /* Shipping protection: a hidden product whose variant (price tier) follows the goods total */
  const isProtection = (item) => !!P && item.product_id === P.productId;
  const goodsOf = (cart) => cart.items.filter((item) => !isProtection(item));
  const goodsCount = (cart) => goodsOf(cart).reduce((n, item) => n + item.quantity, 0);
  const goodsTotal = (cart) => goodsOf(cart).reduce((n, item) => n + item.final_line_price, 0);

  function protectionTier(total) {
    const limits = String(P.limits || '').split(',').map((n) => Math.round(parseFloat(n) * 100)).filter((n) => !Number.isNaN(n));
    let index = limits.findIndex((limit) => total <= limit);
    if (index === -1 || index >= P.variants.length) index = P.variants.length - 1;
    return { id: P.variants[index], price: P.prices[index] };
  }

  function protectionWanted(cart) {
    const flag = cart.attributes && cart.attributes._protection;
    if (flag === 'off') return false;
    if (flag === 'on') return true;
    return !!P.defaultOn;
  }

  function protectionUpdates(cart, wanted) {
    const target = wanted && goodsCount(cart) > 0 ? protectionTier(goodsTotal(cart)).id : null;
    const updates = {};
    cart.items.filter(isProtection).forEach((item) => {
      if (item.variant_id !== target) updates[item.variant_id] = 0;
    });
    if (target) {
      const qty = cart.items.filter((item) => item.variant_id === target).reduce((n, item) => n + item.quantity, 0);
      if (qty !== 1) updates[target] = 1;
    }
    return updates;
  }

  async function postCartUpdate(body) {
    const res = await fetch(`${Saint.routes.cartUpdate}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const cart = await res.json();
    if (cart.status) throw new Error(cart.description || cart.message);
    return cart;
  }

  async function syncProtection(cart) {
    if (!P) return cart;
    const updates = protectionUpdates(cart, protectionWanted(cart));
    if (!Object.keys(updates).length) return cart;
    const updated = await postCartUpdate({ updates });
    updated.protectionChanged = true;
    return updated;
  }

  async function setProtection(on) {
    const cart = await fetchCart();
    return postCartUpdate({ attributes: { _protection: on ? 'on' : 'off' }, updates: protectionUpdates(cart, on) });
  }

  function protectionRow(cart) {
    if (!P || !goodsCount(cart)) return '';
    const on = cart.items.some(isProtection);
    const tier = protectionTier(goodsTotal(cart));
    return `
      <span class="cart-protection__icon">${SHIELD_ICON}</span>
      <span class="cart-protection__text">
        <span class="cart-protection__head"><strong>${escapeHtml(P.title)}</strong><span>${formatMoney(tier.price)}</span></span>
        <span class="cart-protection__desc">${escapeHtml(P.text)}</span>
      </span>
      <button type="button" class="switch" role="switch" aria-checked="${on}" aria-label="${escapeHtml(P.title)}" data-protection-toggle></button>`;
  }

  /* Promo message in cart (display only; discounts are applied by Shopify) */
  function promoMessage(cart) {
    const promo = Saint.promo || {};
    const count = goodsCount(cart);
    if (!count) return null;
    const fill = (str, n, pct) => String(str || '').replace('[count]', n).replace('[percent]', `${pct}%`);
    if (promo.mode === 'bogo') {
      return count % 2 ? { text: promo.bogoHint, progress: 50 } : { text: promo.bogoDone, progress: 100 };
    }
    if (promo.mode === 'progressive') {
      if (count >= 3) return { text: fill(promo.progressiveMax, 0, promo.tier3), progress: 100 };
      return { text: fill(promo.progressiveHint, 1, count === 1 ? promo.tier2 : promo.tier3), progress: count === 1 ? 33 : 66 };
    }
    return null;
  }

  function renderPromo(el, cart) {
    if (!el) return;
    const msg = promoMessage(cart);
    el.hidden = !msg || !msg.text;
    el.innerHTML = el.hidden ? '' : `<p>${escapeHtml(msg.text)}</p><span class="cart-promo__bar"><span style="width:${msg.progress}%"></span></span>`;
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$('[data-cart-count-label]').forEach((el) => (el.textContent = `(${count})`));
  }

  function renderDrawer(cart) {
    const count = goodsCount(cart);
    updateCount(count);
    if (!drawer) return;
    const body = $('[data-cart-items]', drawer);
    const footer = $('[data-cart-footer]', drawer);
    const s = Saint.strings || {};
    renderPromo($('[data-cart-promo]', drawer), cart);
    if (!count) {
      body.innerHTML = `<p class="drawer__empty">${escapeHtml(s.cartEmpty || 'Your cart is empty')}</p>`;
      footer.hidden = true;
      return;
    }
    footer.hidden = false;
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    const discountRow = $('[data-cart-discount-row]', drawer);
    if (discountRow) {
      discountRow.hidden = !cart.total_discount;
      $('[data-cart-discount]', discountRow).textContent = `-${formatMoney(cart.total_discount)}`;
    }
    const protectionEl = $('[data-cart-protection]', drawer);
    if (protectionEl) {
      protectionEl.innerHTML = protectionRow(cart);
      protectionEl.hidden = !protectionEl.innerHTML;
    }
    body.innerHTML = cart.items.map((item, i) => {
      if (isProtection(item)) return '';
      const line = i + 1;
      const img = item.featured_image && item.featured_image.url
        ? `<img src="${item.featured_image.url}${item.featured_image.url.includes('?') ? '&' : '?'}width=180" alt="${escapeHtml(item.product_title)}" loading="lazy">`
        : '';
      const variant = item.product_has_only_default_variant ? '' : `<p class="cart-line__variant">${escapeHtml(item.variant_title || '')}</p>`;
      const compare = item.original_line_price > item.final_line_price ? `<s class="cart-line__compare">${formatMoney(item.original_line_price)}</s> ` : '';
      const discounts = (item.line_level_discount_allocations || [])
        .map((d) => `<span class="cart-line__discount">${TAG_ICON}${escapeHtml((d.discount_application && d.discount_application.title) || '')}</span>`)
        .join('');
      return `
        <div class="cart-line" data-line="${line}">
          <a href="${item.url}" class="cart-line__media">${img}</a>
          <div class="cart-line__info">
            <a href="${item.url}" class="cart-line__title">${escapeHtml(item.product_title)}</a>
            ${variant}
            <p class="cart-line__price">${compare}${formatMoney(item.final_line_price)}</p>
            ${discounts}
            <div class="cart-line__actions">
              <div class="qty qty--sm">
                <button type="button" class="qty__btn" data-line-change="${line}" data-qty="${item.quantity - 1}" aria-label="-"><svg class="icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"/></svg></button>
                <span class="qty__value">${item.quantity}</span>
                <button type="button" class="qty__btn" data-line-change="${line}" data-qty="${item.quantity + 1}" aria-label="+"><svg class="icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>
              </div>
              <button type="button" class="link-btn" data-line-change="${line}" data-qty="0">${escapeHtml(s.remove || 'Remove')}</button>
            </div>
          </div>
        </div>`;
    }).join('');
  }

  async function fetchCart() {
    const res = await fetch(`${Saint.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function refreshCart() {
    const cart = await syncProtection(await fetchCart());
    renderDrawer(cart);
    return cart;
  }

  async function changeLine(line, quantity) {
    drawer && drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${Saint.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
      });
      const cart = await res.json();
      if (cart.status) throw new Error(cart.description || cart.message);
      renderDrawer(await syncProtection(cart));
    } catch (err) {
      toast(err.message || 'Error');
    } finally {
      drawer && drawer.classList.remove('is-loading');
    }
  }

  /* Variant ids chosen in the selected promo offer (one per watch) */
  function promoSlotIds(option, form) {
    const selects = $$('[data-promo-slot]', option);
    if (selects.length) return selects.map((s) => s.value);
    const id = $('input[name="id"]', form).value;
    return Array.from({ length: Number(option.dataset.count) || 1 }, () => id);
  }

  function selectedPromoOption(promo) {
    return $$('[data-promo-option]', promo).find((o) => $('input[type="radio"]', o).checked);
  }

  function promoItems(form) {
    const wrap = form.closest('[data-product]');
    const promo = wrap && $('[data-promo]', wrap);
    const option = promo && selectedPromoOption(promo);
    if (!option) return null;
    const quantities = {};
    promoSlotIds(option, form).forEach((id) => { quantities[id] = (quantities[id] || 0) + 1; });
    return Object.keys(quantities).map((id) => ({ id: Number(id), quantity: quantities[id] }));
  }

  async function addToCart(form, button) {
    const items = promoItems(form);
    button && button.classList.add('is-loading');
    button && button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${Saint.routes.cartAdd}.js`, items
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) }
        : { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      const cart = await refreshCart();
      document.dispatchEvent(new CustomEvent('saint:cart-updated', { detail: cart }));
      if (Saint.cartType === 'drawer' && drawer) {
        openOverlay(drawer);
      } else {
        toast((Saint.strings && Saint.strings.added) || 'Added to cart');
      }
    } catch (err) {
      toast(err.message || 'Error');
    } finally {
      button && button.classList.remove('is-loading');
      button && button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-add], form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax')) return;
    if (Saint.cartType === 'page' && !form.hasAttribute('data-ajax-add')) return;
    e.preventDefault();
    addToCart(form, e.submitter || form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer && Saint.cartType === 'drawer') {
      e.preventDefault();
      refreshCart().catch((err) => toast(err.message || 'Error'));
      openOverlay(drawer);
    }
    if (e.target.closest('[data-drawer-close]')) closeOverlay(drawer);
    const lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn && lineBtn.closest('[data-cart-drawer]')) {
      changeLine(lineBtn.dataset.lineChange, lineBtn.dataset.qty);
    }
  });

  document.addEventListener('click', async (e) => {
    const toggle = e.target.closest('[data-protection-toggle]');
    if (!toggle || !P) return;
    e.preventDefault();
    const on = toggle.getAttribute('aria-checked') !== 'true';
    toggle.setAttribute('aria-checked', String(on));
    toggle.disabled = true;
    try {
      const cart = await setProtection(on);
      if (toggle.closest('[data-cart-page]')) {
        window.location.reload();
        return;
      }
      renderDrawer(cart);
    } catch (err) {
      toggle.setAttribute('aria-checked', String(!on));
      toast(err.message || 'Error');
    } finally {
      toggle.disabled = false;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeOverlay(drawer);
    if (mobileMenu && mobileMenu.classList.contains('is-open')) closeOverlay(mobileMenu);
  });

  /* ---------- Tabs ---------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach((wrap) => {
      if (wrap.dataset.tabsReady) return;
      wrap.dataset.tabsReady = '1';
      $$('[data-tab]', wrap).forEach((tab) => {
        tab.addEventListener('click', () => activateTab(wrap, tab.dataset.tab));
      });
    });
  }
  function activateTab(wrap, id) {
    $$('[data-tab]', wrap).forEach((t) => {
      const on = t.dataset.tab === id;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-tab-panel]', wrap).forEach((p) => {
      const on = p.dataset.tabPanel === id;
      p.hidden = !on;
      p.classList.toggle('is-active', on);
      if (on) updateSlider(p);
    });
  }

  /* ---------- Sliders ---------- */
  function updateSlider(root) {
    const track = $('[data-slider-track]', root);
    if (!track) return;
    const prev = $('[data-slider-prev]', root);
    const next = $('[data-slider-next]', root);
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
    if (next) next.classList.toggle('is-disabled', track.scrollLeft >= max);
  }
  function initSliders(root = document) {
    $$('[data-slider]', root).forEach((slider) => {
      if (slider.dataset.sliderReady) return;
      slider.dataset.sliderReady = '1';
      const track = $('[data-slider-track]', slider);
      if (!track) return;
      const step = () => {
        const item = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const prev = $('[data-slider-prev]', slider);
      const next = $('[data-slider-next]', slider);
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', () => updateSlider(slider), { passive: true });
      window.addEventListener('resize', () => updateSlider(slider));
      updateSlider(slider);
    });
  }

  /* ---------- Accordions (one open at a time) ---------- */
  function initAccordions(root = document) {
    $$('[data-accordion]', root).forEach((acc) => {
      if (acc.dataset.accReady) return;
      acc.dataset.accReady = '1';
      $$(':scope > details', acc).forEach((d) => {
        d.addEventListener('toggle', () => {
          if (!d.open) return;
          $$(':scope > details', acc).forEach((o) => { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Scroll to next section ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scroll-next]');
    if (!btn) return;
    e.preventDefault();
    const section = btn.closest('.shopify-section');
    const next = section && section.nextElementSibling;
    if (next) next.scrollIntoView({ behavior: 'smooth' });
  });

  /* ---------- Promo offer (product page) ---------- */
  function initPromo(wrap, product, form) {
    const promo = $('[data-promo]', wrap);
    if (!promo) return;
    const addBtn = $('[data-add-button]', form);
    const addLabel = addBtn && $('[data-add-label]', addBtn);
    const priceOf = (id) => {
      const v = product.variants.find((x) => String(x.id) === String(id));
      return v ? v.price : 0;
    };

    function update() {
      $$('[data-promo-option]', promo).forEach((option) => {
        const prices = promoSlotIds(option, form).map(priceOf).sort((a, b) => a - b);
        const free = Number(option.dataset.free) || 0;
        const percent = Number(option.dataset.percent) || 0;
        const compare = prices.reduce((a, b) => a + b, 0);
        const pay = Math.round(prices.slice(free).reduce((a, b) => a + b, 0) * (100 - percent) / 100);
        $('[data-promo-price]', option).textContent = formatMoney(pay);
        const cmp = $('[data-promo-compare]', option);
        cmp.textContent = formatMoney(compare);
        cmp.hidden = pay >= compare;
      });
      const option = selectedPromoOption(promo);
      if (addLabel && addBtn && !addBtn.disabled && promo.dataset.addLabel && option && Number(option.dataset.count) > 1) {
        addLabel.textContent = promo.dataset.addLabel;
      }
    }

    promo.addEventListener('change', update);
    wrap.addEventListener('saint:variant', (e) => {
      $$('[data-promo-slot]', promo).forEach((select) => { select.value = e.detail.id; });
      update();
    });
    update();
  }

  /* ---------- Product page ---------- */
  function initProduct(root = document) {
    $$('[data-product]', root).forEach((wrap) => {
      if (wrap.dataset.productReady) return;
      wrap.dataset.productReady = '1';
      const jsonEl = $('[data-product-json]', wrap);
      const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      const form = $('[data-product-form]', wrap);
      const idInput = form && $('input[name="id"]', form);
      const addBtn = form && $('[data-add-button]', form);
      const addLabel = addBtn && $('[data-add-label]', addBtn);
      const priceWrap = $('[data-price]', wrap);
      const mainMedia = $('[data-main-media]', wrap);
      const mainTrack = $('[data-main-track]', wrap);
      const slides = $$('[data-main-slide]', mainMedia);

      /* Gallery: a horizontal track of full-size slides. On mobile it scrolls natively
         (swipe), on desktop overflow is clipped and only thumbnail/variant clicks move it. */
      function showMedia(mediaId, instant) {
        const slide = slides.find((s) => s.dataset.mainSlide === String(mediaId));
        if (!slide || !mainTrack) return;
        mainTrack.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
        $$('[data-thumb]', wrap).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(mediaId)));
      }
      $$('[data-thumb]', wrap).forEach((thumb) => {
        thumb.addEventListener('click', () => showMedia(thumb.dataset.thumb));
      });
      /* Keep the active thumbnail in sync while the visitor swipes the carousel */
      if (mainTrack && slides.length > 1) {
        let raf;
        mainTrack.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const center = mainTrack.scrollLeft + mainTrack.clientWidth / 2;
            let closest = slides[0];
            let min = Infinity;
            slides.forEach((s) => {
              const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
              if (d < min) { min = d; closest = s; }
            });
            const id = closest.dataset.mainSlide;
            $$('[data-thumb]', wrap).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === id));
          });
        }, { passive: true });
        if (wrap.dataset.initialMedia) showMedia(wrap.dataset.initialMedia, true);
      }

      /* Quantity */
      $$('[data-qty-btn]', wrap).forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = $('[data-qty-input]', wrap);
          const val = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qtyBtn));
          input.value = val;
        });
      });

      if (!product || !form) return;

      /* Variants */
      const pickers = $$('[data-option-index]', wrap);
      function selectedOptions() {
        return product.options.map((_, i) => {
          const group = pickers.filter((p) => Number(p.dataset.optionIndex) === i);
          const checked = group.find((p) => p.type === 'radio' ? p.checked : true);
          return checked ? checked.value : null;
        });
      }
      function markAvailability(options) {
        pickers.forEach((input) => {
          if (input.type !== 'radio') return;
          const idx = Number(input.dataset.optionIndex);
          const test = options.slice();
          test[idx] = input.value;
          const match = product.variants.find((v) => v.options.every((o, i) => i === idx || o === test[i] || i > idx) && v.options[idx] === input.value && v.available);
          input.closest('.option__value').classList.toggle('is-unavailable', !match);
        });
        $$('[data-option-selected]', wrap).forEach((el) => {
          el.textContent = options[Number(el.dataset.optionSelected)] || '';
        });
      }
      function onChange() {
        const options = selectedOptions();
        const variant = product.variants.find((v) => v.options.every((o, i) => o === options[i]));
        markAvailability(options);
        const s = Saint.strings || {};
        if (!variant) {
          addBtn.disabled = true;
          addLabel.textContent = s.unavailable || 'Unavailable';
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? (s.addToCart || 'Add to cart') : (s.soldOut || 'Sold out');
        if (priceWrap) {
          $('[data-price-current]', priceWrap).textContent = formatMoney(variant.price);
          const cmp = $('[data-price-compare]', priceWrap);
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          cmp.hidden = !onSale;
          cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          priceWrap.classList.toggle('price--sale', !!onSale);
        }
        if (variant.featured_media) showMedia(String(variant.featured_media.id));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        wrap.dispatchEvent(new CustomEvent('saint:variant', { detail: variant }));
      }
      pickers.forEach((p) => p.addEventListener('change', onChange));
      if (pickers.length) markAvailability(selectedOptions());
      initPromo(wrap, product, form);
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters(root = document) {
    $$('[data-filter-form]', root).forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      form.addEventListener('change', (e) => {
        if (e.target.matches('[data-price-input]')) return;
        submitFilters(form);
      });
      $$('[data-price-input]', form).forEach((input) => {
        input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); submitFilters(form); } });
        input.addEventListener('blur', () => submitFilters(form));
      });
    });
    $$('[data-sort-select]', root).forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
    $$('[data-filters-toggle]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = $('.filters__panel', btn.closest('.filters'));
        const open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function submitFilters(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [key, value] of Array.from(params.entries())) {
      if (value === '') params.delete(key);
    }
    const current = new URL(window.location.href);
    const sort = current.searchParams.get('sort_by');
    if (sort) params.set('sort_by', sort);
    window.location.href = `${window.location.pathname}?${params.toString()}`;
  }

  /* ---------- Cart page ---------- */
  function initCartPage(root = document) {
    $$('[data-cart-page-form]', root).forEach((form) => {
      $$('[data-cart-qty]', form).forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = $(`#${btn.dataset.cartQty}`);
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(btn.dataset.step));
          form.submit();
        });
      });
      $$('input[data-cart-input]', form).forEach((input) => input.addEventListener('change', () => form.submit()));
    });
  }

  /* Keep protection tier / promo message in sync with the cart on every page load */
  function syncOnLoad() {
    const page = $('[data-cart-page]');
    if (!P && !page) return;
    fetchCart()
      .then(syncProtection)
      .then((cart) => {
        if (page && cart.protectionChanged) {
          const stamp = `${cart.token}:${cart.item_count}:${cart.total_price}`;
          let last = null;
          try { last = sessionStorage.getItem('saint-protection-reload'); } catch (e) { /* storage blocked */ }
          if (last !== stamp) {
            try { sessionStorage.setItem('saint-protection-reload', stamp); } catch (e) { /* storage blocked */ }
            window.location.reload();
            return;
          }
        }
        updateCount(goodsCount(cart));
        if (page) renderPromo($('[data-cart-promo]', page), cart);
      })
      .catch(() => {});
  }

  /* ---------- Init ---------- */
  function init(root = document) {
    initTabs(root);
    initSliders(root);
    initAccordions(root);
    initProduct(root);
    initFilters(root);
    initCartPage(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { init(); syncOnLoad(); });
  else { init(); syncOnLoad(); }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const block = e.target;
    const wrap = block.closest('[data-tabs]');
    if (wrap && block.dataset.tab) activateTab(wrap, block.dataset.tab);
    if (block.tagName === 'DETAILS') block.open = true;
  });
})();
